import { formatDate, formatDate_dd_mm_yyyy } from "utils/DateFormatter";
import React, { useState } from "react";
import AddDelinquency from "./AddDelinquency";

const AcrTable = ({ payload, onSuccess }) => {
  const [showModal, setShowModal] = useState(false);
  const [editingData, setEditingData] = useState();

  const { data, created_date, id, empId, updated_date } = payload || {};

  const handleOpenModal = (data = null) => {
    setEditingData(data);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setEditingData(null);
    setShowModal(false);
  };

  const refetch = () => {
    onSuccess(empId);
  };

  const formatValue = (key, value) => {
    const statusFields = [
      "integrityDoubtful",
      "reliabilityDoubtful",
      "representationFiled",
      "representationStatus",
      "decisionOutcome",
      "representationFiledSecondary",
      "representationStatusSecondary",
      "decisionOutcomeSecondary",
    ];

    const dateFields = [
    "assessmentFrom",
    "assessmentTo",
    "decisionDate",
    "decisionDateSecondary",
  ];

  if (dateFields.includes(key)) {
    return value ? formatDate_dd_mm_yyyy(value) : "-";
  }


    if (statusFields.includes(key)) {
      let badgeClass = "badge rounded-pill ";
      let displayValue = value;

      switch (key) {
        case "integrityDoubtful":
        case "reliabilityDoubtful":
          badgeClass += value === "yes" ? "bg-danger" : "bg-success";
          displayValue = value === "yes" ? "Yes" : "No";
          break;

        case "representationFiled":
        case "representationFiledSecondary":
          badgeClass += value === "yes" ? "bg-success" : "bg-warning text-dark";
          displayValue = value === "yes" ? "Filed" : "Not Filed";
          break;

        case "representationStatus":
        case "representationStatusSecondary":
          badgeClass += value === "pending" ? "bg-danger" : "bg-success";
          displayValue = value === "decided" ? "Decided" : "Pending";
          break;

        case "decisionOutcome":
        case "decisionOutcomeSecondary":
          badgeClass +=
            value === "dismissed"
              ? "bg-success"
              : value !== "dismissed"
                ? "bg-danger"
                : "bg-secondary";
          displayValue = value || "Not Decided";
          break;
      }

      return <span className={badgeClass}>{displayValue}</span>;
    }

    return value ?? "-"; // fallback if null/undefined
  };

  // 👇 group fields for clean rows
  const groupedData = [
    [
      { key: "assessmentFrom", label: "Assessment From" },
      { key: "assessmentTo", label: "Assessment To" },
    ],
    [
      { key: "integrityDoubtful", label: "Integrity Doubtful" },
      { key: "reliabilityDoubtful", label: "Reliability Doubtful" },
    ],
    [
      { key: "representationFiled", label: "First Representation Filed" },
      {
        key: "representationFiledSecondary",
        label: "Second Representation Filed ",
      },
    ],
    [
      { key: "representationStatus", label: "First Representation Status" },
      {
        key: "representationStatusSecondary",
        label: "Second Representation Status",
      },
    ],
    [
      { key: "decisionDate", label: "First Decision Date" },
      { key: "decisionOutcomeSecondary", label: "Outcome of second representation" },
    ],

    [
      { key: "decisionDateSecondary", label: "Second Decision Date" },
      { key: "decisionOutcome", label: "First Decision Outcome" },
    ],
    [
      { key: "remarks", label: "Remarks" },
      { key: "remarksSecondary", label: "Second Remarks" },
    ],
  ];

  if (!data) return <p className="text-center">No ACR Data Found</p>;

  return (
    <div className="container py-4">
      <div className="card shadow mb-4">
        <div className="card-header ms-3 me-3 mt-3 bg-dark rounded text-white text-center">
          <div className="d-flex align-items-center justify-content-between">
            <h5 className="mb-0 text-white">Adverse Entry in ACR Details</h5>
            {!["ADMIN", "SUPERADMIN"].includes(
              localStorage.getItem("role"),
            ) && (
              <button
                type="button"
                onClick={() => handleOpenModal(id)}
                className="btn btn-outline-white text-white btn-lg px-3 py-2 shadow-sm"
                style={{ textDecoration: "none" }}
              >
                Update
              </button>
            )}
          </div>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-bordered align-middle">
              <tbody>
                {groupedData.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {row
                      .filter((cell) => data[cell.key] !== undefined)
                      .map((cell, cellIndex) => (
                        <React.Fragment key={cellIndex}>
                          <th className="bg-light">{cell.label}</th>
                          <td>{formatValue(cell.key, data[cell.key])}</td>
                        </React.Fragment>
                      ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="card-footer text-muted text-center small d-flex justify-content-between ">
          <span>Created Date: {formatDate_dd_mm_yyyy(created_date)}</span>
          <span>Last Updated Date: {formatDate_dd_mm_yyyy(updated_date)}</span>
        </div>
      </div>
      <AddDelinquency
        showModal={showModal}
        editingData={editingData}
        onSuccess={refetch}
        handleCloseModal={handleCloseModal}
        empId={empId}
      />
    </div>
  );
};

export default AcrTable;
